import Logo from '../../img/apple-touch-icon.png';
import CloseIcon from '@rsuite/icons/Close';
import './AddToHomeScreen.scss';
import {useState} from "react";

let deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
    deferredPrompt = e;
});

const AddToHomeScreen = () => {
    const [installed, setInstalled] = useState(false);
    const [closed, setClosed] = useState(false);

    if (window.matchMedia('(display-mode: standalone)').matches || isInstall() || closed) {
        return <></>;
    }

    return (<>{!installed && !closed ? <div className="add-to-home-screen">
        <div className="logo">
            <img src={Logo}/>
        </div>

        <div className="title" onClick={install}>
            Add Changaal To Home Screen
        </div>

        <div className="close" onClick={toClose}>
            <CloseIcon/>
        </div>
    </div> : ''}</>);

    function install() {
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                setInstalled(true);
                localStorage.setItem('installed', '1');
            } else {
            }
        })
    }

    function isInstall() {
        return localStorage.getItem('installed') == 1;
    }

    function toClose() {
        setClosed(true);
    }
}

export default AddToHomeScreen;